import React, { useEffect, useState } from "react";
import {
  getUserInfoApi,
  sendToPanelDeliverApi,
} from "../../../../Api/PanelAdminServices";
import Button from "../../../Button/Button";
import Style from "./UserInfo.module.scss";
import { errorToast } from "../../../../Utils/Toast/Toast";

const UserInfo = ({ handleOk, Info, address, showAddress }) => {
  const [disable, setDisable] = useState(false);
  const [userData, setUserData] = useState();
  const goToPanel = () => {
    setDisable(true);
    const info = {
      user_id: Info.userId ?? Info.user_id,
      user_type: "user",
    };
    sendToPanelDeliverApi(info, (res) => {
      setDisable(false);
      window.open(`https://barest.ir/login_as/index.php?token=${res.token}`);
    });
  };
  useEffect(() => {
    getUserInfoApi(Info.userId ?? Info.user_id, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده");
        } else {
          setUserData(res.info);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  }, []);
  return (
    <div className={Style.componentHolder}>
      {userData&&<div className={Style.infoHolder}>
        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleLname}>نام مشتری</p>
          </div>
          <div className={Style.contentHolder}>
            <p
              className={Style.Lname}
            >{`${userData?.first_name} ${userData?.last_name}`}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleEmail}>ایمیل</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.email}>{userData.email ?? " !ایمیل وجود ندارد"}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titlePhone}>شماره تماس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.phone}>{userData.phone}</p>
          </div>
        </div>
        {showAddress ? (
          <div className={Style.row}>
            <div className={Style.titleHolder}>
              <p className={Style.titleAddress}>آدرس</p>
            </div>
            <div className={Style.contentHolder}>
              <p className={Style.address}>{userData.address}</p>
            </div>
          </div>
        ) : null}
      </div>}
      <div className={Style.btnHolder}>
        <Button
          Value={"وارد شدن به پنل مشتری"}
          ClickHandler={goToPanel}
          ClassBtn={"okBtn"}
          disabledprops={disable}
        />
        <Button Value={"تایید"} ClickHandler={handleOk} ClassBtn={"okBtn"} />
      </div>
    </div>
  );
};

export default UserInfo;
